
    import { Vue,Component } from 'vue-property-decorator'
    import { State,Action,namespace } from 'vuex-class'
    import FormBuilder from '../../components/common/form-builder.vue'
    import { AMapManager } from 'vue-amap';
    import fa from "element-ui/src/locale/lang/fa";
    const site = namespace('site')
    @Component({
        components: {
            FormBuilder
        }
    })

    
    export default class EditBranch extends Vue{
        @site.State('info') info:any
        @site.Action('getCheckAuth') getCheckAuth:any
        @site.Action('modifyCheckAuth') modifyCheckAuth:any
        
        amapManager:any = new AMapManager()
        time:any = []
        form:any = {
            name: '',
            sms_address: '',
            phone: '',
            address: '',
            cainiaoToken: '',
            eorderAddress: '',
            tc: '',
            to: '',
            stype: '0',
            hasshelf: true,
            desc: '',
            location: [],
	        vipshelf: false,
            vipshelfstrict: false,
        }
        events:any = {
            address: '',
            location: [],
            init(map:any) {
                const _this =this ;
                AMapUI.loadUI(['misc/PositionPicker'], (PositionPicker:any) => {
                    var positionPicker = new PositionPicker({
                        mode: 'dragMap',
                        map: map
                    });
                    positionPicker.on('success', function (positionResult:any):void {
                        _this.address = positionResult.address
                        _this.location = [positionResult.position.lng,positionResult.position.lat]
                    })
                    positionPicker.start();
                })
            }
        }
        get locationAddress(){
            console.log(this.events.address);
            
            this.form.address = this.events.address
            this.form.location = this.events.location
            return this.events.address
        }
        get formOptions(){
            return [{
                label: '网点名称',
                prop: 'name',
                type: 'input',
                ruleType: 'text'
            },{
                label: '短信地址',
                prop: 'sms_address',
                type: 'input',
                ruleType: 'text'
            },
//	            {
//                label: '网点电话',
//                prop: 'phone',
//                type: 'input',
//                ruleType: 'text'
//            },
	            {
                label: '详细地址',
                prop: 'address',
                type: 'input',
                ruleType: 'text'
            },{
                label: '菜鸟Token',
                prop: 'cainiaoToken',
                type: 'input',
                // ruleType: 'text'
            },{
	            label: '开通一联单',
	            prop: 'newEorderTemplate',
	            type: 'switch',
            },{
                label: '发货地址',
                prop: 'eorderAddress',
                type: 'input',
                // ruleType: 'text'
            },{
                label: '工作时间',
                prop: 'tc',
                type: 'slot',
                ruleType: 'text'
            },{
                label: '编号模式',
                prop: 'stype',
                type: 'select',
                options: [{label:'日期+顺序编号',value: 0},{label:'货架别称+日期+顺序编号',value: 1}],
                optionsLabel: 'label',
                optionsValue: 'value'
            },{
                label: '包含货架',
                prop: 'hasshelf',
                type: 'switch',
            },
            {
                label: 'vip货架',
                prop: 'vipshelf',
                type: 'switch',
            },
            {
                label: 'vip货架严格模式',
                prop: 'vipshelfstrict',
                type: 'switch',
            },{
                label: '网点描述',
                prop: 'desc',
                type: 'textarea',
                row: 2,
                ruleType: 'text'
            }]
        }
        async created(){
			await this.getCheckAuth()
			this.form = {
                name: this.info.name,
                address: this.info.address,
                phone: this.info.phone,
                sms_address: this.info.sms_address,
                cainiaoToken: this.info.cainiaoToken,
                eorderAddress: this.info.eorderAddress,
                tc: this.info.tc,
                to: this.info.to,
                stype: this.info.stype,
                hasshelf: this.info.hasshelf,
                desc: this.info.remarks,
                location: this.info.location,
				newEorderTemplate: this.info.newEorderTemplate,
                vipshelfstrict: this.info.vipshelfstrict,
                vipshelf: this.info.vipshelf,
            }
        }   
        // 确认修改
        async modify(){
            const arr = ['关注', '低至', '下班', '退回'];
            console.log(this.form.sms_address.length);
            
            if(arr.indexOf(this.form.sms_address) > -1) return this.$message.error('短信地址内容含有非法字符');
            if(this.form.sms_address.length > 20){
                this.$confirm('您的短信地址大于20个字将会发送两条短信，收取两条信息费, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                     const res = await this.modifyCheckAuth(this.form)
                     if(res){
                        this.$message({  message: '修改成功', type: 'success' });
//                         this.rest()
                    }
                })
            }else{
                const res = await this.modifyCheckAuth(this.form)
                if(res){
                    this.$message({  message: '修改成功', type: 'success' });
//                     this.rest()
                }
            }
        }
        rest(){
            this.$refs.builder.resetForm()
            this.form.to = ''
        }
    }
